import {HostCard} from "./HostCard";

export default HostCard;